import type { NotificationRouteAccess } from "../types";

import { useAuth } from "@/lib/hooks/useAuth";
import { usePermissionMatrix } from "@/lib/hooks/usePermissionMatrix";

export function useNotificationRouteAccess(): NotificationRouteAccess {
  const { context } = useAuth();
  const { canView } = usePermissionMatrix();

  return { context, canView };
}
